import React from 'react';
import { Typography, Box, Stack, Chip } from '@mui/material';
import dayjs from 'dayjs';

const Fields = ({ data }) => {
  return (
    <div className="mt-3">
      <div>
        <Typography>{data.s_projectName}</Typography>
        <Typography>{data.s_companyName}</Typography>
      </div>
      <div>
        <Typography
          sx={{
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          }}
        >
          {data.s_projectOrderNumber}
        </Typography>
      </div>
      <div className="mt-0.5">
        {data.operations?.map((operation) => {
          const color = operation.plannedTime > operation.timeSpentSoFar ? 'black' : 'red';

          return (
            <Box
              key={operation.st_id}
              display="flex"
              alignItems="center"
              backgroundColor={operation.st_statusColor}
              mb={0.5}
              px={0.5}
              borderRadius={2}
              border="2px solid #8e8e8e"
              position="relative"
              justifyContent="space-between"
            >
              <Typography
                sx={{ fontSize: '0.8rem' }}
              >{`${operation.operationName} ${operation.respPersonName ? `- ${operation.respPersonName}` : ''}`}</Typography>

              <Box mt={0.2}>
                <Typography sx={{ fontSize: '0.8rem', color: color, fontWeight: 'bold' }}>
                  {`${operation.timeSpentSoFar}/${operation.plannedTime}`}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </div>
      <div>
        <Typography>{dayjs(data.dueDate).format('YYYY-MM-DD')}</Typography>
      </div>
      <Stack direction="row" justifyContent="space-between" flexWrap="wrap" gap={1}>
        <Typography>{data.s_total_plannedtime} óra</Typography>
        {data.s_priorityName && (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography>Prioritás:</Typography>
            <Chip
              label={data.s_priorityName}
              size="small"
              sx={{
                backgroundColor: data.s_priorityColor,
                fontWeight: 'bold',
              }}
            />
          </Stack>
        )}
      </Stack>
    </div>
  );
};

export default Fields;
